import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "content"];

  toggle() {
    const isExpanded = this.buttonTarget.getAttribute("aria-expanded") === "true";
    const newState = !isExpanded;

    this.buttonTarget.setAttribute("aria-expanded", String(newState));

    this.contentTarget.classList.toggle("is-expanded", newState);
    this.contentTarget.classList.toggle("is-collapsed", !newState);
  }
}
